import { render, staticRenderFns } from "./Jabatan.vue?vue&type=template&id=5b7c89fe"
import script from "./Jabatan.vue?vue&type=script&lang=js"
export * from "./Jabatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports